import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const MODES = [
  { id: 'none', label: 'None' },
  { id: 'text', label: 'Text' },
  { id: 'image', label: 'Image' },
  { id: 'both', label: 'Text + image' },
];

export function LogoBrandControls({
  compact = false,
  mode,
  onModeChange,
  text,
  onTextChange,
  imageUrl,
  onImageUrlChange,
  onFileSelect,
}) {
  return (
    <div className={compact ? 'space-y-2' : 'space-y-3'}>
      <div className="flex flex-wrap gap-2">
        {MODES.map((m) => (
          <button
            key={m.id}
            type="button"
            onClick={() => onModeChange(m.id)}
            className={`rounded-md px-2 py-1 text-xs border ${
              mode === m.id
                ? 'border-emerald-500 bg-emerald-500/20 text-emerald-300'
                : 'border-slate-600 text-slate-400 hover:border-slate-500'
            }`}
          >
            {m.label}
          </button>
        ))}
      </div>
      {(mode === 'text' || mode === 'both') && (
        <div>
          <Label className="text-xs">Logo text</Label>
          <Input
            value={text}
            onChange={(e) => onTextChange(e.target.value)}
            className="mt-1 bg-slate-800"
            placeholder="Brand name"
          />
        </div>
      )}
      {(mode === 'image' || mode === 'both') && (
        <div>
          <Label className="text-xs">Logo image</Label>
          {imageUrl && (
            <img
              src={imageUrl}
              alt="Logo preview"
              className="mt-1 mb-2 h-10 max-w-[160px] object-contain rounded border border-slate-700"
            />
          )}
          <Input
            type="file"
            accept="image/*"
            className="mt-1"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file && onFileSelect) onFileSelect(file);
              else if (onImageUrlChange) onImageUrlChange('');
            }}
          />
        </div>
      )}
    </div>
  );
}

export default LogoBrandControls;
